import { apiClient } from "../api/apiClient";
import { ProductTag, CreateProductTagRequest, UpdateProductTagRequest } from "../interfaces/ProductTag";

type ResponseDto<T> = {
  loggingHistoryID?: number;
  statusCode: number;
  isSuccess: boolean;
  message: string;
  errors?: string[];
  data?: T;
  dataList?: T[];
};

export const productTagService = {
  getAll: async (): Promise<ResponseDto<ProductTag>> => {
    const response = await apiClient.get<ResponseDto<ProductTag>>("/ProductTags/GetAll");
    return response.data;
  },
  getById: async (productTagID: number): Promise<ResponseDto<ProductTag>> => {
    const response = await apiClient.get<ResponseDto<ProductTag>>(`/ProductTags/GetById/${productTagID}`);
    return response.data;
  },
  create: async (payload: CreateProductTagRequest): Promise<ResponseDto<ProductTag>> => {
    const response = await apiClient.post<ResponseDto<ProductTag>>("/ProductTags/Create", payload);
    return response.data;
  },
  update: async (payload: UpdateProductTagRequest): Promise<ResponseDto<ProductTag>> => {
    const response = await apiClient.put<ResponseDto<ProductTag>>(`/ProductTags/Update/${payload.productTagID}`, payload);
    return response.data;
  },
  delete: async (productTagID: number): Promise<ResponseDto<any>> => {
    const response = await apiClient.delete<ResponseDto<any>>(`/ProductTags/Delete/${productTagID}`);
    return response.data;
  },
};
